import { toast, Slide } from 'react-toastify'

const MOBILE_BREAKPOINT = 768

export const showWarningToast = (message: string) => {
  toast.warning(message, {
    position: window.innerWidth >= MOBILE_BREAKPOINT ? 'bottom-right' : 'bottom-center',
    autoClose: 5000,
    hideProgressBar: true,
    transition: Slide,
    icon: false,
    className: 'border-t-4 border-warning-medium-light',
  })
}
